import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomTextField } from '../../../../../../../../components/CustomTextField';
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 */
const HourScope = ({ rule, updateRule, emptyFields, isValid, disabled }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className='col-12 col-md-6 px-1'>
                <CustomTextField
                    id='txt_hrs_min'
                    name='minValue'
                    value={rule.minValue}
                    trans='min_value'
                    type='number'
                    required
                    emptyFields={emptyFields}
                    onChange={(e) => updateRule(e.target.name, e.target.value)}
                    isValid={isValid}
                    isValidText={"max_value_cannot_be_less_than_min_value"}
                    suffixText={<p className={"ibl-font-w-600 text-uppercase"}>{t('hr')}</p>}
                    length={9}
                    disabled={disabled}
                />
            </div>
            <div className='col-12 col-md-6 px-1'>
                <CustomTextField
                    id='txt_hrs_max'
                    name='maxValue'
                    value={rule.maxValue}
                    trans='max_value'
                    type='number'
                    required
                    emptyFields={emptyFields}
                    onChange={(e) => updateRule(e.target.name, e.target.value)}
                    isValid={isValid}
                    isValidText={"max_value_cannot_be_less_than_min_value"}
                    suffixText={<p className={"ibl-font-w-600 text-uppercase"}>{t('hr')}</p>}
                    length={9}
                    disabled={disabled}
                />
            </div>
        </>
    );
};

export default HourScope;
